export default {
  SATABAPP_STORE: (state, payload) => {
    if(typeof payload.val === 'string') {
      state[payload.key] = ""
      state[payload.key] =  payload.val
    } else {
      state[payload.key] = {}
      state[payload.key] = {...state[payload.key], ...payload.val};
    }
  },
  SATABAPP_RESET: state => {
    state['satabapp-research'] = {};
    state['satabapp-company'] = {};
    state['satabapp-user'] = {};
    state['satabapp-customer'] = {};
    state['satabapp-token'] = {};
    state['satabapp-translation'] = '';
  }
}